const apikey = 'AIzaSyBHT6TiKcrTNsz2LfREcrvisU6a_6S7kG0';

export { apikey };